import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

/**
 * Chặn cửa các màn hình làm việc trong kho: chưa đăng nhập thì về màn đăng nhập.
 *
 * Không có lớp này thì màn hình vẫn vẽ ra bình thường khi phiên đã chết, và lỗi
 * chỉ lộ ra lúc quét mã ô — đúng lúc người cầm máy đang đứng trước kệ và nghĩ
 * mình quét sai.
 */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { user, isAuthLoading } = useAuth();
  const location = useLocation();

  if (isAuthLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <p className="text-sm text-slate-400">Đang kiểm tra phiên đăng nhập...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
